<!-- Одна строка с номером документа и ошибкой из отчёта синхронизации ЭДО. -->
<template>
  <article class="edo-sync-document-error" role="status">
    <span class="edo-sync-document-error__icon" aria-hidden="true">i</span>
    <p class="edo-sync-document-error__text">
      <span class="edo-sync-document-error__title">
        {{ documentNumber }}
      </span>
      <span class="edo-sync-document-error__message">
        — {{ error || "Не удалось полностью обновить данные документа." }}
      </span>
    </p>
  </article>
</template>

<script>
export default {
  name: "EdoSyncDocumentError",

  props: {
    documentNumber: {
      type: [String, Number],
      required: true,
    },
    error: {
      type: String,
      default: null,
    },
  },
};
</script>

<style scoped>
.edo-sync-document-error {
  display: flex;
  gap: 6px;
  padding: 6px 8px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #fff;
}

.edo-sync-document-error__icon {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: #fef3c7;
  color: #a16207;
  font-size: 10px;
  font-weight: 700;
}

.edo-sync-document-error__text {
  margin: 0;
  color: #78716c;
  font-size: 11px;
  line-height: 1.25;
  overflow-wrap: anywhere;
}

.edo-sync-document-error__title {
  color: #854d0e;
  font-weight: 600;
}

.edo-sync-document-error__message {
  color: #78716c;
}
</style>
